<div fxLayout="row" class="error">
  <span>
    <mat-icon class="icon-display">warning</mat-icon>
  </span>
  <span style="font-size: 0.8em; line-height: 1rem"
    >Error: {{ error?.message }}</span
  >
</div>
